import BaseBlockContent from '@sanity/block-content-to-react'
import React from 'react'
import Figure from './figure'
import { H1, H2, H3, H4, H5, H6, P } from '../Typography'

const serializers = {
  types: {
    block(props) {
      switch (props.node.style) {
        case 'h1':
          return <H1>{props.children}</H1>
        case 'h2':
          return <H2>{props.children}</H2>
        case 'h3':
          return <H3>{props.children}</H3>
        case 'h4':
          return <H4>{props.children}</H4>
        case 'h5':
          return <H5>{props.children}</H5>
        case 'h6':
          return <H6>{props.children}</H6>
        default:
          return <P>{props.children}</P>
      }
    },
    figure (props) {
      return <Figure {...props.node} />
    },
  },
}

const TextBlock = ({ blocks }) => (
  <BaseBlockContent blocks={blocks} serializers={serializers} />
)

export default TextBlock
